module.exports = {

    getSizeWithinMax: function(width, height, maxWidth, maxHeight, opts)
    {
        opts = _.extend({
            cover: false,
            multipleOfTwo: false,
        }, opts);

        if (!width || width <= 0 || !height || height <= 0)
        {
            return {
                width: 0,
                height: 0,
                ratio: 1
            }
        }

        maxWidth = maxWidth ? maxWidth : width;
        maxHeight = maxHeight ? maxHeight : height;

        var ratioWidth = Math.round(maxWidth) / width;
        var ratioHeight = Math.round(maxHeight) / height;
        var ratio = opts.cover ? Math.max(ratioWidth, ratioHeight) : Math.min(ratioWidth, ratioHeight);

        var computedWidth = Math.round(width * ratio);
        var computedHeight = Math.round(height * ratio);

        return {
            width: computedWidth,
            height: computedHeight,
            ratio: ratio,
        };
    },

    getValueInPixels: function(size, max)
    {
        max = typeof max !== 'undefined' ? max:1;

        if(_.isString(size) && size.match(/[0-9]+\%$/))
        {
            var percent = parseFloat(size.match(/([0-9\.]+)\%$/)[1]);
            percent = percent * (size.substr(0,1) === '-' ? -1:1);
            return max * percent/100;
        }
        else if (_.isNumber(size))// if its a float from 0 to 1
        {
            return size * max;
        } else {
            return size;
        }
    },

    setSizeAndPositionFromRefSize: function(objects, refWidth, refHeight, opts)
    {
        opts = _.merge({
            offsetX: 0,
            offsetY: 0,
            position: {
                x: 0,
                y: 0
            },
            scale: {
                x: null,
                y: null
            },
            anchor: {
                x: null,
                y: null
            },
            rotation: 0
        }, opts);

        opts.scale.x = opts.scale.x === null && opts.scale.y === null ? 1:opts.scale.x;
        var x = opts.offsetX + refWidth * this.getValueInPixels(opts.position.x);
        var y = opts.offsetY + refHeight * this.getValueInPixels(opts.position.y);
        var scaleX = this.getValueInPixels(opts.scale.x);
        var scaleY = this.getValueInPixels(opts.scale.y);

        objects = _.isArray(objects) ? objects : [objects];

        var i, il, width, height, object;
        for (i = 0, il = objects.length; i < il; i++)
        {
            object = objects[i];

            if (scaleX === null && scaleY !== null)
            {
                height = refHeight * scaleY;
                width = object.width / object.height * height;
            } else if (scaleX !== null && scaleY === null){
                width = refWidth * scaleX;
                height = object.height / object.width * width;
            } else if (scaleX !== null && scaleY !== null){
                //console.log('warning: streching object!', object);
                width = refWidth * scaleX;
                height = refHeight * scaleY;
            } else {
                //console.log('warning: keeping object size from texture!', object);
                width = object.width;
                height = object.height;
            }

            if (opts.anchor.x !== null)
            {
                object.anchor.x = opts.anchor.x;
            }

            if (opts.anchor.y !== null)
            {
                object.anchor.y = opts.anchor.y;
            }

            object.x = x;
            object.y = y;
            object.width = width;
            object.height = height;
            object.rotation = opts.rotation * Math.PI / 180;
        }
    },

    setSizeAndPositionFromRefSprite: function(objects, refSprite, opts)
    {
        opts = _.extend({
            offsetX: refSprite.x,
            offsetY: refSprite.y
        }, opts);

        this.setSizeAndPositionFromRefSize(objects, refSprite.width, refSprite.height, opts);
    },

    updateMovieclipParams: function(movieclip, params, frameChangedCallback)
    {
        var frame = Math.min(movieclip.totalFrames, Math.floor(params.frame));

        if (movieclip.currentFrame !== frame)
        {
            movieclip.gotoAndStop(frame);
            if (frameChangedCallback)
            {
                frameChangedCallback(movieclip, frame);
            }
        }
    },

    isAudioContextSupported: function()
    {
        var supported = false;
        try {
            window.AudioContext = new (window.AudioContext || window.webkitAudioContext)();
            window.AudioContext.createStereoPanner();
            supported = true;
        }
        catch(e) {}
        return supported;
    },

    getComponentFromType: function(Components, type)
    {
        var Component;

        if (type)
        {
            Component = _.find(Components, function(Component, key)
            {
                return type.replace(/[^a-z0-9]/gi,'').toLowerCase() === key.toLowerCase();
            });
        }

        return !Component ? Components[Object.keys(Components)[0]]:Component;
    },

    getColorIntFromString: function(str)
    {
        if (typeof str === 'undefined')
        {
            return 0;
        }

        return parseInt(str.replace('#','0x'));
    },

    getColorStringFromInt: function(int)
    {
        var hex = Number(int).toString(16);
        return '#'+'000000'.substr(0, 6 - hex.length) + hex;
    },

    onPreventStop: (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
            // console.log('e', event);
        }
    }
};



// WEBPACK FOOTER //
// ./js/lib/utils.js